import { UserPermissions } from '@features/profile';
import { userPermissionsList } from '@features/profile/components/InviteUsersModal/constants';

export const multipleUsersKey = 'multipleUsers';
export const errorMessage = 'Sorry, something went wrong';

export const timezones = {
  'America/New_York': 'Eastern',
  'America/Chicago': 'Central',
  'America/Denver': 'Mountain',
  'America/Los_Angeles': 'Pacific',
  'America/Phoenix': 'Mountain (Arizona)',
  'America/Anchorage': 'Alaska',
  'Pacific/Honolulu': 'Hawaii-Aluetian',
} as const;

export const timezonesShortNames = {
  'America/New_York': 'EDT',
  'America/Chicago': 'CDT',
  'America/Denver': 'MDT',
  'America/Los_Angeles': 'PDT',
  'America/Phoenix': 'MST',
  'America/Anchorage': 'AKDT',
  'Pacific/Honolulu': 'HST',
  'Asia/Karachi': 'PKT',
  'Australia/Sydney': 'AEST',
  'Australia/Melbourne': 'AEST',
  'Australia/Brisbane': 'AEST',
  'Australia/Perth': 'AWST',
  'Australia/Adelaide': 'ACST',
  'Australia/Darwin': 'ACST',
  'Australia/Hobart': 'AEST',
} as const;

export const AustraliaTimezones = {
  'Australia/Perth': 'Australian Western Standard Time (AWST)',
  'Australia/Eucla': 'Australian Central Western Standard Time (ACWST)',
  'Australia/Adelaide': 'Australian Central Standard Time (ACST)',
  'Australia/Sydney': 'Australian Eastern Standard Time (AEST)',
  'Australia/Darwin': 'Australian Central Standard Time (ACST)',
  'Australia/Melbourne': 'Australian Eastern Standard Time (AEST)',
  'Australia/Brisbane': 'Australian Eastern Standard Time (AEST)',
  'Australia/Hobart': 'Australian Eastern Standard Time (AEST)',
  'Australia/Lord_Howe': 'Lord Howe Standard Time (LHST)',
} as const;

export const canadianTimezones = {
  'America/St_Johns': 'Newfoundland Standard Time (NST)',
  'America/Halifax': 'Atlantic Standard Time (AST)',
  'America/Glace_Bay': 'Atlantic Standard Time (AST)',
  'America/Moncton': 'Atlantic Standard Time (AST)',
  'America/Toronto': 'Eastern Standard Time (EST)',
  'America/Montreal': 'Eastern Standard Time (EST)',
  'America/Thunder_Bay': 'Eastern Standard Time (EST)',
  'America/Winnipeg': 'Central Standard Time (CST)',
  'America/Regina': 'Central Standard Time (CST)',
  'America/Swift_Current': 'Central Standard Time (CST)',
  'America/Edmonton': 'Mountain Standard Time (MST)',
  'America/Yellowknife': 'Mountain Standard Time (MST)',
  'America/Dawson_Creek': 'Mountain Standard Time (MST)',
  'America/Vancouver': 'Pacific Standard Time (PST)',
  'America/Whitehorse': 'Pacific Standard Time (PST)',
  'America/Dawson': 'Pacific Standard Time (PST)'
} as const;

// export const AustraliaTimezones = {
//   'Australia/Sydney': 'Australian Eastern Standard Time (AEST)',
//   'Australia/Eucla': 'Australian Central Western Standard Time (ACWST)',
//   'Australia/Lord_Howe': 'Lord Howe Standard Time (LHST)',
//   'Australia/Darwin': 'Australian Central Standard Time (ACST)',
//   'Australia/Perth': 'Australian Western Standard Time (AWST)',
// } as const;
export const AustraliaTimezonesShortNames = {
  'Australia/Sydney': 'AEST',  
  'Australia/Melbourne': 'AEST',  
  'Australia/Brisbane': 'AEST',  
  'Australia/Perth': 'AWST',
  'Australia/Adelaide': 'ACST',  
  'Australia/Darwin': 'ACST', 
  'Australia/Hobart': 'AEST', 
} as const;


export const initialPermissionsValue: UserPermissions = {
  permissions: userPermissionsList.map((permission) => permission.id).join(','),
  restricted_positions: '',
};

export const getTimeZoneAbbreviation = () => {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return (timezonesShortNames[tz as keyof typeof timezonesShortNames]);
};
